var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 32,
    fill: "#FF6B55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1834 53.8165L50.0001 47.6832C52.4003 44.6905 53.5626 40.892 53.2481 37.0687C52.9336 33.2453 51.1662 29.6878 48.3093 27.1276C45.4524 24.5674 41.7231 23.199 37.8883 23.304C34.0535 23.4089 30.4046 24.9791 27.692 27.6917C24.9794 30.4044 23.4091 34.0532 23.3042 37.888C23.1993 41.7229 24.5676 45.4521 27.1278 48.309C29.6881 51.166 33.2456 52.9334 37.0689 53.2479C40.8923 53.5623 44.6908 52.4 47.6834 49.9998L53.8168 56.1332C53.9717 56.2894 54.156 56.4134 54.3591 56.498C54.5622 56.5826 54.7801 56.6262 55.0001 56.6262C55.2201 56.6262 55.438 56.5826 55.641 56.498C55.8441 56.4134 56.0285 56.2894 56.1834 56.1332C56.4838 55.8224 56.6517 55.4071 56.6517 54.9748C56.6517 54.5426 56.4838 54.1273 56.1834 53.8165ZM38.3334 49.9998C36.026 49.9998 33.7703 49.3156 31.8518 48.0337C29.9332 46.7517 28.4378 44.9296 27.5548 42.7978C26.6718 40.666 26.4408 38.3202 26.8909 36.0571C27.3411 33.794 28.4522 31.7152 30.0838 30.0836C31.7155 28.452 33.7943 27.3408 36.0574 26.8907C38.3205 26.4405 40.6663 26.6716 42.7981 27.5546C44.9299 28.4376 46.7519 29.9329 48.0339 31.8515C49.3158 33.7701 50.0001 36.0257 50.0001 38.3332C50.0001 41.4274 48.7709 44.3948 46.583 46.5828C44.3951 48.7707 41.4276 49.9998 38.3334 49.9998Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.249c5302.svg";
export { ForwardRef as ReactComponent };